export enum UserPermissionsForGroupsEnum {
    groupStats = 'group_stats',
    usersStats = 'users_stats',
}